import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[profileAppNumericInput]'
})
export class ProfieNumericInputDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    let sanitizedValue = initialValue.replace(/[^0-9+]/g, '');
    if (!sanitizedValue.startsWith('+91')) {
      sanitizedValue = '+91' + sanitizedValue.replace(/\D/g, ''); 
    }
    let formattedValue = sanitizedValue.slice(0, 13); 
    if (initialValue !== formattedValue) {
      this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
      event.stopPropagation(); // Prevent event propagation
    }
  }

}